import { motion } from "framer-motion";
const GenerationSkeleton: React.FC = ({}) => {
  const bgColor = "bg-slate-700";
  const borderColor = "border-slate-700";
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className={`${bgColor} backdrop-blur-sm shadow-xl rounded-xl p-6 border ${borderColor} h-fit`} data-sentry-element="unknown" data-sentry-component="GenerationSkeleton" data-sentry-source-file="index.tsx">
            <div className="space-y-4 animate-pulse">
                <div className="h-8 bg-slate-400 rounded w-3/4"></div>
                <div className="space-y-2">
                    <div className="h-4 bg-slate-400 rounded w-1/2"></div>
                    <div className="h-4 bg-slate-400 rounded w-full"></div>
                </div>
                <div className="space-y-2">
                    <div className="h-4 bg-slate-400 rounded w-1/3"></div>
                    <div className="h-4 bg-slate-400 rounded w-full"></div>
                    <div className="h-4 bg-slate-400 rounded w-2/3"></div>
                </div>
            </div>
        </motion.div>;
};
export default GenerationSkeleton;